<template>
	<div id="Property_Assessment" class="property-assessment">
		<div class="prop-assessment-cont">
			<div class="assessment-info">
				<div class="first-info">
					<div class="header5">Property</div>
					<div class="header3">Assessment</div>
					<div class="paragraph info-text">
						<p>
							Your property assessed value is based on the estimated market value that the County has placed on your property. In Cook
							County the property's assessed value is {{ property.percentageOfMarketValue }}% of the market value for residential
							properties.
						</p>
						<p>
							The assessed value is comprised of a <em>land assessed value</em> and a <em>building assessed value</em>. The County uses
							the <em>building assessed value per square foot</em> to compare similar properties and judge the fairness of a property's
							assessment.
						</p>
					</div>
				</div>
				<div class="estimated-value card">
					<div class="est-value">
						<div class="header2">{{ property.estimatedMarketValue | toCurrency }}</div>
						<div class="label-text">County Estimated Market Value</div>
					</div>
				</div>
			</div>
			<div class="assessment-cards-cont">
				<PropertyAssessmentCard
					v-bind:analysisValue="property.currentTotalAssessment.toString() | toCurrency"
					analysisLabel="Current Total Assessment"
					iconName="currentTotal"
					iconBackgroundColor="purple"
				/>

				<PropertyAssessmentCard
					v-bind:analysisValue="property.currentBuildAssessment.toString() | toCurrency"
					analysisLabel="Current Building Assessment"
					iconName="currentBuilding"
					iconBackgroundColor="soft-purple"
				/>

				<PropertyAssessmentCard
					v-bind:analysisValue="property.assessmentPerSq.toString() | toCurrency"
					analysisLabel="Building Assessment Per Square Foot"
					iconName="assesmentPerSq"
					iconBackgroundColor="primary"
				/>
				<PropertyAssessmentCard
					v-bind:analysisValue="property.currentLandAssessment.toString() | toCurrency"
					analysisLabel="Current Land Assessment"
					iconName="currentLand"
					iconBackgroundColor="accent"
				/>
			</div>

			<div class="button-cont" @click="nextButton">
				<i class="material-icons arrow-link">east</i>
				<div class="link-button">How do I compare to my neighbors?</div>
			</div>
		</div>
	</div>
</template>

<script>
import PropertyAssessmentCard from "@/components/property/PropertyAssessmentCard.vue";
import Button from "@/components/ui/Button.vue";

export default {
	name: "property-assessment",
	components: {
		PropertyAssessmentCard,
		Button,
	},
	computed: {
		property() {
			return this.$store.getters.getAllPropertyData;
		},
	},
	methods: {
		nextButton() {
			this.scroll("#Neighborhood_Analysis");
		},
		scroll(to) {
			const element = document.querySelector(to);
			let offset = 56;

			window.scrollTo({
				top: element.offsetTop - offset,
				left: 0,
				behavior: "smooth",
			});
		},
	},
};
</script>

<style scoped lang="scss">
.property-assessment {
	// width: 1600px;
	display: flex;
	flex-direction: column;
	background: rgba(196, 196, 196, 0.1);
	display: flex;
	padding: 60px;
	text-align: left;
	position: relative;
	.prop-assessment-cont {
		margin: 0 auto;
		max-width: 1600px;
	}
	.link-button {
		color: var(--accent);
		margin-top: 8px;
		font-weight: 500;
		font-size: 18px;
		cursor: pointer;
		border-bottom: 2px solid var(--accent);
		line-height: 30px;
	}
	.arrow-link {
		background: var(--accent);
		color: white;
		border-radius: 20px;
		margin-left: 10px;
		padding: 6px;
		cursor: pointer;
	}
	.button-cont {
		text-align: left;
		display: flex;
		flex-direction: row-reverse;
		margin-top: 50px;
		align-items: flex-end;
	}
	.assessment-cards-cont {
		margin-top: 40px;
		display: grid;
		// grid-template-columns: repeat(auto-fit, minmax(503px, 1fr));
		grid-template-columns: repeat(auto-fit, minmax(517px, 1fr));
		// grid-template-columns: auto auto;
		grid-gap: 25px;
	}
	.assessment-info {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(600px, 1fr));
		grid-gap: 35px;
	}
	.first-info {
		margin-right: 20px;
	}
	.property-value,
	.estimated-value {
		display: flex;
		flex-direction: row;
	}
	.estimated-value.card {
		padding: 25px;
		height: 98px;
		width: max-content;
		justify-self: end;
	}
	.north-icon-cont {
		margin-right: 35px;
	}
	.info-text {
		color: #000000;
		margin-top: 30px;
	}
	.header5 {
		color: var(--accent);
	}
	.header3 {
		font-size: 36px;
		line-height: 36px;
		color: var(--black);
		margin-top: 8px;
	}
	.header2 {
		font-size: 51px;
		line-height: 100%;
		color: var(--black);
		text-align: left;
	}
	.label-text {
		font-weight: 500;
		font-size: 18px;
		line-height: 27px;
		color: var(--text);
		text-transform: uppercase;
	}
}
@media screen and (max-width: 768px) {
	.property-assessment {
		height: unset;
	}
}
@media screen and (max-width: 414px) {
	.property-assessment {
		padding: 3rem 1rem;
		.assessment-cards-cont,
		.assessment-info {
			display: grid;
			// grid-template-columns: repeat(auto-fit, minmax(372px, 1fr));
			grid-template-columns: 1fr;
		}
		.estimated-value {
			width: unset !important;
			justify-self: unset;
		}
	}
}
</style>
